import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { AppModalService } from '../../../../shared/services/app-modal.service';
import { combineLatest, Observable } from 'rxjs';
import { CookieService } from '../../../../shared/services/cookie.service';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../../../store/state/app.state';
import { isVipSelector } from '../../../../store/selectors/billing.selectors';
import { ClickhouseService } from '../../../../shared/services/clickhouse.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() ticketStatus!: any;

  // waiting_for_lock
  // waiting_for_solve
  // hide
  @Input() timeToLock!: any;

  //   "time_to_lock": {
  //     "time_to_lock_for_user_real": 120,
  //     "time_to_lock_for_user_fake": 120,
  //     "time_added_lock_time_expired": 60,
  //     "message_if_lock_time_expired": "Sorry, we still need 1 minutes more minutes to find the best expert for your task."
  //   },
  @Input() timeToSolve!: any;

  //   "time_to_solve": {
  //     "time_to_solve_for_user_real": 300,
  //     "time_to_solve_for_user_fake": 120,
  //     "time_added_solve_time_expired": 120,
  //     "message_if_solve_time_expired": "Sorry, we still need 2 more minutes to provide the solution to your task."
  //   }
  // }
  @Input() markSolved!: boolean;

  @Input() ticketId!: number;

  timerWidth = 0;

  time = 0;

  timerEnd = 0;

  progressTimer: any;

  timerObject: any;

  retentionModalClose: any;

  isVipSubscription: boolean | null = false;

  constructor(
    private myModalService: AppModalService,
    private store: Store<AppStateInterface>,
    private clickHouseService: ClickhouseService,
    private router: Router,
  ) {
    combineLatest([this.store.select(isVipSelector)]).subscribe(([isVip]) => {
      this.isVipSubscription = isVip;
    });
  }

  get currentTime() {
    let m = Math.floor(this.time / 60);
    let s = this.time % 60;
    let mS = `${m}`.length === 1 ? `0${m}` : `${m}`;
    let sS = `${s}`.length === 1 ? `0${s}` : `${s}`;
    return `${mS}:${sS}`;
  }

  ngOnInit(): void {
    this.reInitProgress();
  }

  // 0{{ minutes }}:{{ seconds.toString().length === 1 ? `0${seconds }` : seconds }}

  ngOnChanges() {
    this.retentionModalClose?.unsubscribe();
    this.reInitProgress();
  }

  openVipComponent() {
    this.router.navigate(['/vip']);
    return this.clickHouseService.storeEvent('Get_Priority_Progress_open_close_click');
  }

  ngOnDestroy(): void {
    this.clearData();
  }

  private reInitProgress() {
    if (this.ticketStatus === 'waiting_for_lock') {
      this.progress(
        this.timeToLock.time_to_lock_for_user_real,
        this.timeToLock.time_added_lock_time_expired,
        this.timeToLock.message_if_lock_time_expired,
        'waiting_for_lock',
      ).subscribe((timerData: any) => {
        this.timerWidth = timerData.width;
        this.time = timerData.timerTick;
        this.timerEnd = timerData.timerEnd;
      });
    } else if (this.ticketStatus === 'waiting_for_solve' && !this.markSolved) {
      this.progress(
        this.timeToSolve.time_to_solve_for_user_real,
        this.timeToSolve.time_added_solve_time_expired,
        this.timeToSolve.message_if_solve_time_expired,
        'waiting_for_solve',
      ).subscribe((timerData: any) => {
        this.timerWidth = timerData.width;
        this.time = timerData.timerTick;
        this.timerEnd = timerData.timerEnd;
      });
    } else {
      this.clearData();
    }
  }

  private progress(
    timerEnd: number,
    additionalTime: number,
    expiredMessage: string,
    progressPart: string,
  ) {
    return new Observable((subscriber) => {
      this.progressTimer?.unsubscribe();
      clearInterval(this.timerObject);
      this.timerObject = 0;
      this.progressTimer = this.timer(timerEnd, progressPart).subscribe((data: any) => {
        if (data === 'Directed by...') {
          this.progressTimer.unsubscribe();
          subscriber.next({
            width: 100,
            timerTick: timerEnd,
            timerEnd: timerEnd + additionalTime,
          });
          const modal = this.myModalService.open({
            content: expiredMessage,
            title: 'Oooops...',
            canClose: true,
          });
          this.retentionModalClose = modal.closed.subscribe(() => {
            this.additionalProgress(
              timerEnd + additionalTime,
              expiredMessage,
              progressPart,
              timerEnd,
              additionalTime,
            ).subscribe((i) => {
              subscriber.next(i);
            });
          });
        } else {
          subscriber.next(data);
        }
      });
    });
  }

  private additionalProgress(
    timerEnd: number,
    expiredMessage: string,
    progressPart: string,
    timerStart: number,
    additionalTime: number,
  ) {
    return new Observable((subscriber) => {
      this.progressTimer?.unsubscribe();
      clearInterval(this.timerObject);
      this.timerObject = 0;
      this.progressTimer = this.timer(timerEnd, progressPart, timerStart).subscribe((data: any) => {
        if (data === 'Directed by...') {
          this.progressTimer.unsubscribe();
          const modal = this.myModalService.open({
            content: expiredMessage,
            title: 'Oooops...',
            canClose: true,
          });
          this.retentionModalClose = modal.closed.subscribe(() => {
            console.log(timerEnd + additionalTime, timerEnd, additionalTime);
            this.additionalProgress(
              timerEnd + additionalTime,
              expiredMessage,
              progressPart,
              timerEnd,
              additionalTime,
            ).subscribe((i) => {
              subscriber.next(i);
            });
          });
        } else {
          subscriber.next(data);
        }
      });
    });
  }

  private timer(timerEnd: number, progressPart: string, timerStart?: number) {
    return new Observable((subscriber) => {
      let timerTick = timerStart
        ? timerStart
        : CookieService.getCookie(`timer_${this.ticketId}_${progressPart}`)
        ? JSON.parse(CookieService.getCookie(`timer_${this.ticketId}_${progressPart}`)!).timerTick
        : 0;
      let timerHappyEnd = timerStart
        ? timerEnd
        : CookieService.getCookie(`timer_${this.ticketId}_${progressPart}`)
        ? JSON.parse(CookieService.getCookie(`timer_${this.ticketId}_${progressPart}`)!)
            .timerHappyEnd
        : timerEnd;
      this.timerObject = setInterval(() => {
        if (timerTick <= timerHappyEnd) {
          timerTick += 1;
          subscriber.next({
            width: (100 / timerHappyEnd) * timerTick,
            timerTick: timerTick,
            timerEnd: timerHappyEnd,
          });
        } else {
          subscriber.next('Directed by...');
          clearInterval(this.timerObject);
          this.timerObject = 0; // its mean Nothing
        }
        CookieService.setCookie(
          `timer_${this.ticketId}_${progressPart}`,
          JSON.stringify({
            timerTick,
            timerHappyEnd,
          }),
          {
            expires: this.expiresAfterHour(),
          },
        );
      }, 1000);
    });
  }

  private clearData() {
    this.progressTimer?.unsubscribe();
    if (this.timerObject) {
      clearInterval(this.timerObject);
      this.timerObject = 0;
    }
    CookieService.deleteCookie(`timer_${this.ticketId}_waiting_for_lock`);
    CookieService.deleteCookie(`timer_${this.ticketId}_waiting_for_solve`);
  }

  private expiresAfterHour(): string {
    const now = new Date();
    let time = now.getTime();
    time += 3600 * 1000;
    now.setTime(time);
    return now.toUTCString();
  }
}
